/* eslint-disable react/prop-types */

import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { HiArrowLeft } from 'react-icons/hi';
import { Col, Row } from 'reactstrap';
import { Button, DatePicker, Input } from '../../../../../common/components';
import { dateFormat, reports } from '../../../../../utils/constant';
import { getDecimalNumber, getPrice } from '../../../../../utils/formatters';
import DownloadModal from '../../../downloadModal/downloadModal';
import EmailModal from '../../../emailModal/emailModal';
import Toolbar from '../../../toolbar/toolbar';
import PayOffInfoTable from './PayOffInfoTable';

const PayoffCalculateFilter = ({
  setShowCalculateFilter,
  calculateHandler,
  amountTableData,
  setAmountTableData,
}) => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [date, setDate] = useState(moment().format('MM-DD-YYYY'));
  const [amountToBePaid, setAmountToBePaid] = useState(
    getPrice(amountTableData?.data?.originalPayOffAmount),
  );
  const [amountToBePaidNumber, setAmountToBePaidNumber] = useState(
    amountTableData?.data?.originalPayOffAmount,
  );
  useEffect(() => {
    setAmountToBePaidNumber(amountTableData?.data?.payOffAmount);
    setAmountToBePaid(getPrice(amountTableData?.data?.payOffAmount));
  }, [amountTableData]);

  const toggleEmailModal = () => {
    if (amountTableData?.showTable) {
      setIsEmailModalOpen(!isEmailModalOpen);
    }
  };

  const toggleDownloadModal = () => {
    if (amountTableData?.showTable) {
      setIsDownloadModalOpen(!isDownloadModalOpen);
    }
  };
  const calculateTableHandler = () => {
    let proposedDateTime;
    if (date) {
      proposedDateTime = moment(date).isSame(moment(), 'day')
        ? moment().utc().format('YYYY-MM-DD HH:mm:ss')
        : moment(date).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
      proposedDateTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');
    }
    calculateHandler({
      proposedDate: proposedDateTime,
      amountToBePaid: getDecimalNumber(amountToBePaidNumber),
      timezone: moment.tz.guess(),
    });
  };

  return (
    <div>
      <Toolbar
        title="Pay Off Report"
        optionOneLabel="Email Report"
        optionOneIcon="MdOutlineEmail"
        onOptionOneClick={toggleEmailModal}
        optionTwoLabel="Download Report"
        optionTwoIcon="FiDownload"
        onOptionTwoClick={toggleDownloadModal}
        isTableDataPresent={amountTableData?.showTable}
      />
      <div className="pay-off-new">
        <div className="pay-off-heading">
          <HiArrowLeft
            onClick={() => {
              setShowCalculateFilter(false);
              setAmountTableData({ data: [], showTable: false });
            }}
          />
        </div>
        <Row>
          <Col lg={4} className="pay-off-col-inp">
            <Input
              disabled
              name="segmentValue"
              className="pay-off-input"
              placeholder="CONTRACT ID"
              label="CONTRACT ID"
              value={amountTableData?.data?.contractNumber}
            />
          </Col>
          <Col lg={4} className="pay-off-col-inp">
            <DatePicker
              required
              name="enter date"
              className="datepicker-wrapper pay-off-input"
              formInput={false}
              placeholder="Date"
              label="Proposed Date"
              value={date}
              onChange={([selectedDate]) => {
                setDate(selectedDate);
              }}
              options={{
                minDate: moment().format('YYYY-MM-DD'),
                dateFormat: dateFormat.M_D_Y,
              }}
              kind="md"
            />
          </Col>
          <Col lg={4} className="pay-off-col-inp">
            <Input
              name="segmentValue"
              className="pay-off-input"
              placeholder="Amount to be paid"
              label="Amount to be paid"
              value={amountToBePaid}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[+-]?\d*(?:[.,]\d{0,2})?$/;
                if (regex.test(value) && value <= amountTableData?.data?.originalPayOffAmount) {
                  setAmountToBePaidNumber(
                    // eslint-disable-next-line no-restricted-globals
                    Number
                      // eslint-disable-next-line no-restricted-globals
                      .isNaN(parseFloat(value))
                      ? 0
                      : value,
                  );
                  setAmountToBePaid(value);
                }
              }}
              onFocus={() => {
                setAmountToBePaid(amountToBePaidNumber);
              }}
              onBlur={() => {
                setAmountToBePaid(getPrice(amountToBePaidNumber));
              }}
              pattern="[+-]?\d+(?:[.,]\d+)?"
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg={8}>
            <p className="pay-off-text">{`The amount required to pay in full is  ${getPrice(
              amountTableData?.data?.originalPayOffAmount,
            )}`}</p>
            <p className="pay-off-principal-interest">
              {`Principal: ${getPrice(
                amountTableData?.data?.payOffPrincipal,
              )}, Interest: ${getPrice(
                amountTableData?.data?.payOffInterest,
              )} and Unfinanced due: ${getPrice(amountTableData?.data?.unfinancedAmount)}`}
            </p>
          </Col>
          <Col className="mt-auto" lg={4}>
            <Button onClick={calculateTableHandler} color="primary" className="pay-off-btn">
              Calculate
            </Button>
          </Col>
        </Row>
      </div>
      {amountTableData?.showTable && <PayOffInfoTable data={amountTableData?.data} />}
      <EmailModal
        isOpen={isEmailModalOpen}
        toggle={toggleEmailModal}
        reportType={reports?.PAY_OFF_REPORT_CALCULATE}
        apiValues={{
          contractNumber: amountTableData?.data?.contractNumber,
          proposedDate: date ? moment(date).format(dateFormat.YEAR_MONTH_DAY) : moment().format(),
        }}
      />
      <DownloadModal
        isOpen={isDownloadModalOpen}
        toggle={toggleDownloadModal}
        reportType={reports?.PAY_OFF_REPORT_CALCULATE}
        urlParams={{
          contractNumber: amountTableData?.data?.contractNumber,
          proposedDate: date ? moment(date).format(dateFormat.YEAR_MONTH_DAY) : moment().format(),
        }}
      />
    </div>
  );
};

export default PayoffCalculateFilter;
